import { Box, InputLabel, TextField, Theme, InputLabelProps, TextFieldProps } from '@mui/material';
import type { SystemStyleObject } from '@mui/system';

export interface TextInputProps {
  id?: string;
  label?: string;
  sx?: SystemStyleObject<Theme>;
  required?: boolean;
  placeholder?: string;
  LabelProps?: InputLabelProps;
  FieldProps?: TextFieldProps;
  error?: string;
}
export const TextInput: React.FC<TextInputProps> = ({
  id,
  label,
  sx,
  LabelProps,
  FieldProps,
  required,
  placeholder,
  error,
}) => {
  return (
    <Box sx={[{ mb: 2.5 }, sx || {}]}>
      {label && (
        <InputLabel {...LabelProps} htmlFor={id} required={required}>
          {label}
        </InputLabel>
      )}
      <TextField
        variant="outlined"
        fullWidth
        {...FieldProps}
        error={Boolean(error)}
        helperText={error}
        id={id}
        placeholder={placeholder}
      />
    </Box>
  );
};
